import { AfterContentInit, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { GraphicActionInterface } from '../../../../../utils/models/common.interface';
import { ButtonInduxtry } from '../../../../../utils/models/input.interface';

@Component({
  selector: 'graphic-actions',
  templateUrl: './graphic-actions.component.html',
  styleUrls: ['./graphic-actions.component.scss']
})
export class GraphicActionsComponent implements AfterContentInit {
  @Output() graphicActionEmitter: EventEmitter<string> = new EventEmitter<string>();

  @Input() graphicActions: GraphicActionInterface;

  buttonSelect: ButtonInduxtry;
  buttonZoomIn: ButtonInduxtry;
  buttonZoomOut: ButtonInduxtry;
  buttonRefresh: ButtonInduxtry;

  constructor(private readonly cdref: ChangeDetectorRef) {
    this.constructInterfaces()
  }

  ngAfterContentInit(): void {
    this.cdref.detectChanges()
  }

  constructInterfaces() {
    this.buttonSelect = { label: '', icon: 'Selection', showLabel: false, customStyle: 'primary', disabled: false }
    this.buttonZoomIn = { label: '', icon: 'Zoomin', showLabel: false, customStyle: 'primary', disabled: false }
    this.buttonZoomOut = { label: '', icon: 'Zoomout', showLabel: false, customStyle: 'primary', disabled: false }
    this.buttonRefresh = { label: '', icon: 'refresh', showLabel: false, customStyle: 'primary', disabled: false }
  }

  actionEmitted(event) {
    this.graphicActionEmitter.emit(event);
  }

  disableAction(action: 'zoomIn' | 'zoomOut' | 'dragmode' | 'refresh' | 'all', disabled: boolean) {
    const actionMap = {
      'zoomIn': this.buttonZoomIn,
      'zoomOut': this.buttonZoomOut,
      'dragmode': this.buttonSelect,
      'refresh': this.buttonRefresh
    };

    if (action === 'all') {
        Object.values(actionMap).forEach(button => button.disabled = disabled);
    } else if (action in actionMap) {
        actionMap[action].disabled = disabled;
    }
  }
}
